module.exports = __webpack_public_path__ + "static/media/dsr_journey1.b9f51af7.svg";